// src/pages/Careers/careersData.js

export const companyPulseData = [
  { value: "30+", label: "Clients Served" },
  { value: "10+", label: "Team Members" },
  { value: "5+", label: "Industries Served" },
  { value: "10+", label: "Active Projects" },
  { value: "2+", label: "Products in Development" },
];

export const buildingProductsData = [
  {
    id: "campbee-crm",
    title: "CampBee CRM",
    description: "A CRM platform for businesses to manage, follow up with, and convert leads effectively.",
    tags: ["React", "Node.js", "MongoDB", "AI"],
    icon: "Users",
  },
  {
    id: "smart-digital-pen",
    title: "Smart Digital Pen",
    description: "Hardware + software innovation focused on digital interaction and intuitive learning.",
    tags: ["Embedded", "Hardware", "Software"],
    icon: "PenTool",
  },
  {
    id: "client-solutions",
    title: "Client Solutions",
    description: "Custom software solutions and scalable digital products for businesses across different industries.",
    tags: ["Web Apps", "Mobile Apps", "AI/ML"],
    icon: "Code2",
  },
];

export const whyJoinData = [
  {
    id: "real-projects",
    title: "Real Projects",
    description: "Work on technology that real businesses use every day to solve actual problems.",
    icon: "Briefcase",
  },
  {
    id: "learn-by-building",
    title: "Learn by Building",
    description: "Gain hands-on experience with modern technologies, frameworks, and tools.",
    icon: "Zap",
  },
  {
    id: "collaborative-team",
    title: "Collaborative Team",
    description: "Work with a supportive, friendly, and ambitious team that grows together.",
    icon: "UserCheck",
  },
  {
    id: "product-development",
    title: "Product Development",
    description: "Be an essential part of building and scaling our own in-house SaaS & hardware products.",
    icon: "Layers",
  },
  {
    id: "career-growth",
    title: "Career Growth",
    description: "Take on bigger challenges, lead projects, and accelerate your career as we expand.",
    icon: "TrendingUp",
  },
];

export const jobCategories = [
  "All",
  "Development",
  "Design",
  "AI / Data",
  "Business",
  "Marketing",
  "Internship",
];

export const jobPositionsData = [
  {
    id: "full-stack-developer",
    title: "Full Stack Developer",
    category: "Development",
    location: "Chennai / Hybrid",
    experience: "0–2 Years / Freshers",
    type: "Full-time / Internship",
    skills: ["React", "Node.js", "MongoDB", "Express", "REST APIs"],
    description:
      "We are looking for a passionate Full Stack Developer who loves building fast, responsive web applications and scalable backend APIs.",
    responsibilities: [
      "Develop user interfaces using React.js and modern styling solutions.",
      "Build and maintain RESTful APIs and backend services using Node.js & MongoDB.",
      "Collaborate with UI/UX designers and product managers to deliver seamless user experiences.",
      "Optimize application performance and ensure code quality through code reviews."
    ],
    requirements: [
      "Proficiency in JavaScript/TypeScript, React.js, and Node.js.",
      "Familiarity with MongoDB, Mongoose, or relational databases.",
      "Basic understanding of Git, RESTful APIs, and asynchronous programming.",
      "Strong problem-solving skills and eagerness to learn new tech stacks."
    ],
    learning: [
      "Architecting scalable multi-tenant SaaS platforms.",
      "Integrating AI microservices with frontend interfaces.",
      "Production deployment pipelines and cloud infrastructure."
    ]
  },
  {
    id: "frontend-developer",
    title: "Frontend Developer",
    category: "Development",
    location: "Chennai / Remote",
    experience: "0–2 Years / Freshers",
    type: "Full-time / Internship",
    skills: ["React", "TypeScript", "Tailwind CSS", "Framer Motion"],
    description:
      "Join us to craft beautiful, lightning-fast, and responsive user interfaces that captivate users and provide delightful interactive experiences.",
    responsibilities: [
      "Translate designs and wireframes into high-quality, pixel-perfect React code.",
      "Implement smooth micro-animations and interactive state management.",
      "Ensure cross-browser compatibility and mobile responsiveness.",
      "Optimize web assets for maximum speed and accessibility."
    ],
    requirements: [
      "Strong foundation in HTML5, CSS3, JavaScript (ES6+), and React.",
      "Hands-on experience with Tailwind CSS or modern utility CSS frameworks.",
      "Eye for design details, typography, and UX flow.",
      "Understanding of component-driven development."
    ],
    learning: [
      "Advanced motion graphics & Framer Motion layout transitions.",
      "Next.js server-side rendering & performance auditing.",
      "Building reusable enterprise design systems."
    ]
  },
  {
    id: "ai-ml-engineer",
    title: "AI / ML Engineer",
    category: "AI / Data",
    location: "Chennai / Hybrid",
    experience: "0–2 Years / Freshers",
    type: "Full-time / Internship",
    skills: ["Python", "Machine Learning", "AI APIs", "FastAPI", "PyTorch"],
    description:
      "Help us integrate cutting-edge AI capability, LLM agents, and automated data processing into our products and client software solutions.",
    responsibilities: [
      "Research, prototype, and deploy machine learning models and AI workflows.",
      "Integrate OpenAI, Claude, or open-source LLM APIs into production applications.",
      "Build data extraction, processing pipelines, and vector database indexes.",
      "Evaluate model performance and optimize latency for real-time applications."
    ],
    requirements: [
      "Proficiency in Python and data libraries (Pandas, NumPy, Scikit-learn).",
      "Hands-on project experience with LLM APIs, LangChain, or PyTorch/TensorFlow.",
      "Understanding of REST APIs and web servers (FastAPI/Flask).",
      "Curiosity to stay updated with rapidly evolving AI technologies."
    ],
    learning: [
      "RAG (Retrieval-Augmented Generation) architecture design.",
      "Fine-tuning models for niche domain applications.",
      "Deploying scalable AI agent pipelines."
    ]
  },
  {
    id: "ui-ux-designer",
    title: "UI/UX Designer",
    category: "Design",
    location: "Chennai / Hybrid",
    experience: "0–2 Years",
    type: "Full-time / Internship",
    skills: ["Figma", "UI/UX", "Wireframing", "Prototyping", "Design Systems"],
    description:
      "Design intuitive web and mobile interfaces that simplify complex workflows for our SaaS products and client applications.",
    responsibilities: [
      "Create wireframes, user flows, visual mockups, and interactive prototypes in Figma.",
      "Collaborate with developers to ensure design fidelity during implementation.",
      "Conduct user research and iterate on feedback to optimize conversion and usability.",
      "Maintain and expand our core design system components."
    ],
    requirements: [
      "Proficiency in Figma and modern prototyping tools.",
      "Strong visual sense for typography, color theory, grid systems, and dark/light UI.",
      "Portfolio showcasing UI/UX project case studies or web designs.",
      "Good communication skills to explain design decisions."
    ],
    learning: [
      "Designing complex data dashboards & interactive tools.",
      "Design tokens & automated developer handover workflows.",
      "Usability testing and conversion-driven UX patterns."
    ]
  },
  {
    id: "business-development-executive",
    title: "Business Development Executive",
    category: "Business",
    location: "Chennai / Remote",
    experience: "0–2 Years",
    type: "Full-time / Internship",
    skills: ["Sales", "Lead Generation", "CRM", "Client Outreach", "Negotiation"],
    description:
      "Drive business expansion by identifying prospective clients, pitching our digital solutions, and building strategic relationships.",
    responsibilities: [
      "Identify target prospects, generate qualified leads, and initiate contact.",
      "Present software products and custom solution offerings to potential clients.",
      "Manage lead pipelines in CampBee CRM from outreach to closing.",
      "Gather market feedback to help shape product feature roadmaps."
    ],
    requirements: [
      "Strong verbal and written communication & presentation skills.",
      "Proactive attitude toward outreach, networking, and relationship building.",
      "Basic understanding of the tech industry, web apps, and digital products.",
      "Goal-driven mindset with strong organizational habits."
    ],
    learning: [
      "Enterprise software sales strategy & pitch refinement.",
      "CRM automation tactics for automated lead nurturing.",
      "Strategic partnership acquisition and client account management."
    ]
  },
  {
    id: "digital-marketing-executive",
    title: "Digital Marketing Executive",
    category: "Marketing",
    location: "Chennai / Remote",
    experience: "0–2 Years",
    type: "Full-time / Internship",
    skills: ["SEO", "Social Media", "Content Marketing", "Meta Ads", "Analytics"],
    description:
      "Expand Crack Developers' digital brand presence through creative content, targeted campaigns, SEO optimization, and social media engagement.",
    responsibilities: [
      "Plan and execute content campaigns across LinkedIn, Instagram, and web blogs.",
      "Optimize website content and landing pages for organic SEO visibility.",
      "Manage paid ad campaigns (Meta Lead Forms, Google Search Ads).",
      "Track marketing analytics and generate actionable campaign reports."
    ],
    requirements: [
      "Experience with social media management, copy content creation, and SEO basics.",
      "Familiarity with analytics tools (Google Analytics, Search Console, Meta Business Suite).",
      "Creative mindset with good written communication skills.",
      "Interest in tech branding and developer community engagement."
    ],
    learning: [
      "Growth hacking strategies for B2B SaaS solutions.",
      "Data-driven ad budget allocation & ROAS optimization.",
      "Building brand authority in the software engineering landscape."
    ]
  }
];

export const journeyStagesData = [
  {
    stage: "01",
    title: "Join",
    description: "Step into an active tech environment where your energy, ideas, and talent are welcomed from day one.",
    icon: "UserPlus"
  },
  {
    stage: "02",
    title: "Learn",
    description: "Work directly alongside experienced builders, mastering modern tools, frameworks, and workflows.",
    icon: "BookOpen"
  },
  {
    stage: "03",
    title: "Build",
    description: "Ship real software—contribute to production products and client platforms with immediate impact.",
    icon: "Code"
  },
  {
    stage: "04",
    title: "Own",
    description: "Take ownership of features, modules, or client accounts as your confidence and skill grow.",
    icon: "ShieldCheck"
  },
  {
    stage: "05",
    title: "Grow",
    description: "Expand your career trajectory, lead technical or business initiatives, and scale with the company.",
    icon: "Rocket"
  }
];

export const recruitmentStepsData = [
  {
    number: "01",
    title: "Apply",
    description: "Submit your resume, portfolio, or GitHub profile via our quick online form."
  },
  {
    number: "02",
    title: "Profile Review",
    description: "Our core team reviews your background, skills, and project history."
  },
  {
    number: "03",
    title: "Technical Discussion",
    description: "An informal chat about your past projects, problem-solving style, and tech interests."
  },
  {
    number: "04",
    title: "Interview",
    description: "Meet the founders and team members to align on culture, expectations, and role fit."
  },
  {
    number: "05",
    title: "Welcome to Crack Developers",
    description: "Receive your offer, onboarding kit, and start building real software with us!"
  }
];

export const lifeAtCrackGallery = [
  {
    id: 1,
    title: "Collaborative Workspace",
    category: "Work",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 2,
    title: "Brainstorming & Architecture",
    category: "Collaboration",
    image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 3,
    title: "Team Discussions",
    category: "Team",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 4,
    title: "Modern Office Environment",
    category: "Office",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 5,
    title: "Milestone Celebrations",
    category: "Events",
    image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 6,
    title: "Pair Programming & Mentorship",
    category: "Collaboration",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop",
  }
];
